<template>
    <el-drawer
        title="新增员工"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="activeTab" class="fx-g1 fx-col inner_tags-page">
                <el-tab-pane label="添加员工" name="addNew">
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="员工姓名">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="手机电话">
                            <el-input v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="登录密码">
                            <div class="fx-col">
                                <el-input v-model="form.password" show-password></el-input>
                                <span class="text_info tr">*不提供密码则使用默认密码123456</span>
                            </div>

                        </el-form-item>
                        <el-form-item label="单点登录Token" v-if="showSSO">
                            <el-input v-model="form.ssoToken" ></el-input>

                        </el-form-item>
                        <el-form-item label="使用期限">
                            <div class="fx-col">
                                <el-date-picker
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    v-model="form.expireTime"
                                    type="date"
                                    placeholder="选择使用期限">
                                </el-date-picker>
                            </div>

                        </el-form-item>
                        <el-form-item label="角色">
                            <el-checkbox-group v-model="form.roles">
                                <el-checkbox-group v-model="form.roles">
                                    <el-checkbox v-for="item in roles" :label="item.id+''" :key="item.id">{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>

                </el-tab-pane>
                <el-tab-pane label="从会员添加" name="addFromLib">
                    <div class="fx-g1 fx-col fx-c_stretch">
                        <el-form ref="form" :model="form2" label-width="80px" class="edit_form">
                            <el-form-item label="关键词">
                                <el-input v-model="form2.keywords" suffix-icon="el-icon-search" style="width: 260px;margin-right: 20px"></el-input>
                                <span class="text_primary">*选择用户后，请选择角色授权</span>
                            </el-form-item>
                        </el-form>

                        <el-table
                            ref="userTable"
                            :data="tableData"
                            stripe
                            class="fx-g1"
                            style="width: 100%"
                            @selection-change="handleUserChoose"
                        >
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                prop="name"
                                label="用户名称" >
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                label="角色授权" >
                                <template slot-scope="scope">
                                    <el-checkbox-group :disabled="choosedUser.indexOf(scope.row) == -1" v-model="scope.row.roles" class="fx-col fx-m_start fx-c_start">
                                        <el-checkbox v-for="item in roles" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                prop="phone"
                                label="手机号" >
                            </el-table-column>
                            <el-table-column
                                prop="sn"
                                min-width="120"
                                label="系统账号" >
                            </el-table-column>
                        </el-table>
                        <div class=" fx fx-m_end fx-c_center" style="height: 50px">
                            <el-pagination
                                :background="true"
                                prev-text="上一页"
                                next-text="下一页"
                                layout="prev, pager, next"
                                :current-page="pager.currentPage"
                                :page-size="pager.pageSize"
                                :total="pager.dataTotal"
                                @current-change="pageChange"
                            >
                            </el-pagination>
                        </div>
                    </div>

                </el-tab-pane>
            </el-tabs>


        </div>
        <span  class="fx fx-center">
            <el-button v-if="activeTab=='addNew'" type="primary" @click="subOne()">添 加</el-button>
            <el-button v-if="activeTab=='addFromLib'" type="primary" @click="subBatch()">添 加</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .edit_form {
        margin-top: 20px;
        width: 88%;
    }
</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                activeTab: "addNew",
                roles: [],
                form: {...this.item, roles:[], fromChannel: 1, ssoToken:''},
                form2: {},
                tableData: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                choosedUser: [],
                needRefreshParent: false,
                showSSO: false,
            }

        },
        watch: {
            "form2": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadUsers();
                },
                deep: true

            }
        },

        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            subOne() {
                if (this.form.ssoToken && this.form.ssoToken.length <8) {
                    this.$showError("单点登录Token长度不能小于8");
                    return false;
                }
                let data = {...this.form, roles: this.form.roles.join(",")};
                this.$ajaxPost("/user/save", {
                    user: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            subBatch() {
                if (this.choosedUser.length == 0) {
                    this.$showError("请选取后再操作");
                    return;
                }
                let users = this.choosedUser.map(item => {
                    return {...item, roles: item.roles.join(",")}
                })

                this.$ajaxPost("/user/addPositionsFromUsers", {
                    users: users
                }, (data) => {
                    this.$showSuccess("添加成功");
                    this.$emit("submit");
                    this.needRefreshParent = true;
                })
                return false;
            },
            handleUserChoose(val) {
                this.choosedUser = val;
            },
            loadRoles() {
                this.$ajaxPost("/role/list", {
                    form: {
                        enable: true
                    }
                }, (data) => {
                    this.roles = data.result;
                })
            },
            loadUsers() {
                this.$ajaxPost("/user/listNotStaffUsers", {
                    form: this.form2,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    data.result.forEach(item => {
                        item.roles = [];
                    })
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadUsers();
            }

        },
        mounted() {
            this.show = true;
            this.showSSO = window.location.host.startsWith(process.env.VUE_APP_SSO_HOST+".");
        },
        created() {
            this.loadRoles();
            this.loadUsers();
        }


    }
</script>
